// permissions-part1.js
export const PERMISSIONS = {
  // Answer - Clear Image
  DELETE_QUESTION_OPTIONS_CLEAR_IMG_TEACHER: {
    path: "/api/v1/question-options/:id/clear-img",
    method: "DELETE",
    model: "answer",
    scope: "teacher",
  },
  DELETE_QUESTION_OPTIONS_CLEAR_IMG_ADMIN: {
    path: "/api/v1/question-options/:id/clear-img",
    method: "DELETE",
    model: "answer",
    scope: "admin",
  },
  DELETE_QUESTIONS_CLEAR_IMG_TEACHER: {
    path: "/api/v1/questions/:id/clear-img",
    method: "DELETE",
    model: "questions",
    scope: "teacher",
  },
  DELETE_QUESTIONS_CLEAR_IMG_ADMIN: {
    path: "/api/v1/questions/:id/clear-img",
    method: "DELETE",
    model: "questions",
    scope: "admin",
  },

  // Point Wallets
  POST_POINT_WALLETS_ADMIN: {
    path: "/api/v1/point-wallets",
    method: "POST",
    model: "point_wallets",
    scope: "admin",
  },
  POST_POINT_WALLETS_STUDENT: {
    path: "/api/v1/point-wallets",
    method: "POST",
    model: "point_wallets",
    scope: "student",
  },
  GET_POINT_WALLETS_ME_STUDENT: {
    path: "/api/v1/point-wallets/me",
    method: "GET",
    model: "point_wallets",
    scope: "student",
  },
  GET_POINT_WALLETS_ME_ADMIN: {
    path: "/api/v1/point-wallets/me",
    method: "GET",
    model: "point_wallets",
    scope: "admin",
  },
  GET_POINT_WALLETS_ADMIN: {
    path: "/api/v1/point-wallets",
    method: "GET",
    model: "point_wallets",
    scope: "admin",
  },
  GET_POINT_WALLETS_STUDENT: {
    path: "/api/v1/point-wallets",
    method: "GET",
    model: "point_wallets",
    scope: "student",
  },
  GET_POINT_WALLETS_BY_ID_ADMIN: {
    path: "/api/v1/point-wallets/:id",
    method: "GET",
    model: "point_wallets",
    scope: "admin",
  },
  GET_POINT_WALLETS_BY_ID_STUDENT: {
    path: "/api/v1/point-wallets/:id",
    method: "GET",
    model: "point_wallets",
    scope: "student",
  },
  POST_POINT_WALLETS_PURCHASE_POINTS_ADMIN: {
    path: "/api/v1/point-wallets/purchase-points",
    method: "POST",
    model: "point_wallets",
    scope: "admin",
  },
  POST_POINT_WALLETS_PURCHASE_POINTS_STUDENT: {
    path: "/api/v1/point-wallets/purchase-points",
    method: "POST",
    model: "point_wallets",
    scope: "student",
  },

  // Wallets
  POST_WALLETS_EDFALI_CONFIRM_STUDENT: {
    path: "/api/v1/wallets/edfali/confirm",
    method: "POST",
    model: "wallets",
    scope: "student",
  },
  POST_WALLETS_EDFALI_CONFIRM_ADMIN: {
    path: "/api/v1/wallets/edfali/confirm",
    method: "POST",
    model: "wallets",
    scope: "admin",
  },
  POST_WALLETS_EDFALI_INITIATE_STUDENT: {
    path: "/api/v1/wallets/edfali/initiate",
    method: "POST",
    model: "wallets",
    scope: "student",
  },
  POST_WALLETS_EDFALI_INITIATE_ADMIN: {
    path: "/api/v1/wallets/edfali/initiate",
    method: "POST",
    model: "wallets",
    scope: "admin",
  },
  POST_WALLETS_MASARAT_CONFIRM_STUDENT: {
    path: "/api/v1/wallets/masarat/confirm",
    method: "POST",
    model: "wallets",
    scope: "student",
  },
  POST_WALLETS_MASARAT_CONFIRM_ADMIN: {
    path: "/api/v1/wallets/masarat/confirm",
    method: "POST",
    model: "wallets",
    scope: "admin",
  },
  POST_WALLETS_MASARAT_INITIATE_STUDENT: {
    path: "/api/v1/wallets/masarat/initiate",
    method: "POST",
    model: "wallets",
    scope: "student",
  },
  POST_WALLETS_MASARAT_INITIATE_ADMIN: {
    path: "/api/v1/wallets/masarat/initiate",
    method: "POST",
    model: "wallets",
    scope: "admin",
  },
  GET_WALLETS_PAYMENT_SERVICES: {
    path: "/api/v1/wallets/payment-services",
    method: "GET",
    model: "wallets",
    scope: "public",
  },
  GET_WALLETS_ME_STUDENT: {
    path: "/api/v1/wallets/me",
    method: "GET",
    model: "wallets",
    scope: "student",
  },
  GET_WALLETS_ME_ADMIN: {
    path: "/api/v1/wallets/me",
    method: "GET",
    model: "wallets",
    scope: "admin",
  },
  POST_WALLETS_ADMIN: {
    path: "/api/v1/wallets",
    method: "POST",
    model: "wallets",
    scope: "admin",
  },
  POST_WALLETS_STUDENT: {
    path: "/api/v1/wallets",
    method: "POST",
    model: "wallets",
    scope: "student",
  },
  GET_WALLETS_ADMIN: {
    path: "/api/v1/wallets",
    method: "GET",
    model: "wallets",
    scope: "admin",
  },
  GET_WALLETS_STUDENT: {
    path: "/api/v1/wallets",
    method: "GET",
    model: "wallets",
    scope: "student",
  },
  GET_WALLETS_BY_ID_ADMIN: {
    path: "/api/v1/wallets/:id",
    method: "GET",
    model: "wallets",
    scope: "admin",
  },
  GET_WALLETS_BY_ID_STUDENT: {
    path: "/api/v1/wallets/:id",
    method: "GET",
    model: "wallets",
    scope: "student",
  },
  DELETE_WALLETS_BY_ID: {
    path: "/api/v1/wallets/:id",
    method: "DELETE",
    model: "wallets",
    scope: "admin",
  },

  // Prepaid Cards
  GET_PREPAID_CARDS: {
    path: "/api/v1/prepaid-cards",
    method: "GET",
    model: "prepaid_cards",
    scope: "admin",
  },
  POST_PREPAID_CARDS: {
    path: "/api/v1/prepaid-cards",
    method: "POST",
    model: "prepaid_cards",
    scope: "admin",
  },
  POST_PREPAID_CARDS_REDEEM: {
    path: "/api/v1/prepaid-cards/redeem",
    method: "POST",
    model: "prepaid_cards",
    scope: "student",
  },
  GET_PREPAID_CARDS_BY_ID: {
    path: "/api/v1/prepaid-cards/:id",
    method: "GET",
    model: "prepaid_cards",
    scope: "admin",
  },

  // Exams
  POST_EXAMS_BULK_CSV_TEACHER: {
    path: "/api/v1/exams/bulk-csv",
    method: "POST",
    model: "exams",
    scope: "teacher",
  },
  POST_EXAMS_BULK_CSV_ADMIN: {
    path: "/api/v1/exams/bulk-csv",
    method: "POST",
    model: "exams",
    scope: "admin",
  },
  GET_EXAMS_TEACHER: {
    path: "/api/v1/exams",
    method: "GET",
    model: "exams",
    scope: "teacher",
  },
  GET_EXAMS_ADMIN: {
    path: "/api/v1/exams",
    method: "GET",
    model: "exams",
    scope: "admin",
  },
  GET_EXAMS_PUBLIC: {
    path: "/api/v1/exams",
    method: "GET",
    model: "exams",
    scope: "public",
  },
  GET_EXAMS_BY_ID_TEACHER: {
    path: "/api/v1/exams/:id",
    method: "GET",
    model: "exams",
    scope: "teacher",
  },
  GET_EXAMS_BY_ID_ADMIN: {
    path: "/api/v1/exams/:id",
    method: "GET",
    model: "exams",
    scope: "admin",
  },
  GET_EXAMS_BY_ID_PUBLIC: {
    path: "/api/v1/exams/:id",
    method: "GET",
    model: "exams",
    scope: "public",
  },
  POST_EXAMS_TEACHER: {
    path: "/api/v1/exams",
    method: "POST",
    model: "exams",
    scope: "teacher",
  },
  POST_EXAMS_ADMIN: {
    path: "/api/v1/exams",
    method: "POST",
    model: "exams",
    scope: "admin",
  },
  PUT_EXAMS_BY_ID_TEACHER: {
    path: "/api/v1/exams/:id",
    method: "PUT",
    model: "exams",
    scope: "teacher",
  },
  PUT_EXAMS_BY_ID_ADMIN: {
    path: "/api/v1/exams/:id",
    method: "PUT",
    model: "exams",
    scope: "admin",
  },
  DELETE_EXAMS_BY_ID_TEACHER: {
    path: "/api/v1/exams/:id",
    method: "DELETE",
    model: "exams",
    scope: "teacher",
  },
  DELETE_EXAMS_BY_ID_ADMIN: {
    path: "/api/v1/exams/:id",
    method: "DELETE",
    model: "exams",
    scope: "admin",
  },

  // Promotions
  PUT_PROMOTIONS_BY_ID: {
    path: "/api/v1/promotions/:id",
    method: "PUT",
    model: "promotions",
    scope: "admin",
  },
  POST_PROMOTIONS: {
    path: "/api/v1/promotions",
    method: "POST",
    model: "promotions",
    scope: "admin",
  },
  DELETE_PROMOTIONS_BY_ID: {
    path: "/api/v1/promotions/:id",
    method: "DELETE",
    model: "promotions",
    scope: "admin",
  },
  GET_PROMOTIONS_BY_ID_TEACHER: {
    path: "/api/v1/promotions/:id",
    method: "GET",
    model: "promotions",
    scope: "teacher",
  },
  GET_PROMOTIONS_BY_ID_ADMIN: {
    path: "/api/v1/promotions/:id",
    method: "GET",
    model: "promotions",
    scope: "admin",
  },
  GET_PROMOTIONS_TEACHER: {
    path: "/api/v1/promotions",
    method: "GET",
    model: "promotions",
    scope: "teacher",
  },
  GET_PROMOTIONS_ADMIN: {
    path: "/api/v1/promotions",
    method: "GET",
    model: "promotions",
    scope: "admin",
  },

  // Statistics
  GET_STATISTICS_CUSTOMER: {
    path: "/api/v1/statistics",
    method: "GET",
    model: "processes",
    scope: "customer",
  },
  GET_STATISTICS_PROCESSES_ADMIN: {
    path: "/api/v1/statistics",
    method: "GET",
    model: "processes",
    scope: "admin",
  },

  // User Completed Exams
  POST_USER_COMPLETED_EXAMS_SUBMIT_ADMIN: {
    path: "/api/v1/user-completed-exams/submit/:id",
    method: "POST",
    model: "user-completed-exams",
    scope: "admin",
  },
  POST_USER_COMPLETED_EXAMS_SUBMIT_STUDENT: {
    path: "/api/v1/user-completed-exams/submit/:id",
    method: "POST",
    model: "user-completed-exams",
    scope: "student",
  },
  GET_USER_COMPLETED_EXAMS_BY_ID_ADMIN: {
    path: "/api/v1/user-completed-exams/:id",
    method: "GET",
    model: "user-completed-exams",
    scope: "admin",
  },
  GET_USER_COMPLETED_EXAMS_BY_ID_STUDENT: {
    path: "/api/v1/user-completed-exams/:id",
    method: "GET",
    model: "user-completed-exams",
    scope: "student",
  },
  GET_USER_COMPLETED_EXAMS_SUMMARY_ADMIN: {
    path: "/api/v1/user-completed-exams/summary/:id",
    method: "GET",
    model: "user-completed-exams",
    scope: "admin",
  },
  GET_USER_COMPLETED_EXAMS_SUMMARY_STUDENT: {
    path: "/api/v1/user-completed-exams/summary/:id",
    method: "GET",
    model: "user-completed-exams",
    scope: "student",
  },
  GET_USER_COMPLETED_EXAMS_ADMIN: {
    path: "/api/v1/user-completed-exams",
    method: "GET",
    model: "user-completed-exams",
    scope: "admin",
  },
  GET_USER_COMPLETED_EXAMS_STUDENT: {
    path: "/api/v1/user-completed-exams",
    method: "GET",
    model: "user-completed-exams",
    scope: "student",
  },

  // Point Packages
  DELETE_POINT_PACKAGES_BY_ID: {
    path: "/api/v1/point-packages/:id",
    method: "DELETE",
    model: "point-packages",
    scope: "admin",
  },
  GET_POINT_PACKAGES_BY_ID_ADMIN: {
    path: "/api/v1/point-packages/:id",
    method: "GET",
    model: "point-packages",
    scope: "admin",
  },
  GET_POINT_PACKAGES_BY_ID_PUBLIC: {
    path: "/api/v1/point-packages/:id",
    method: "GET",
    model: "point-packages",
    scope: "public",
  },
  PUT_POINT_PACKAGES_BY_ID: {
    path: "/api/v1/point-packages/:id",
    method: "PUT",
    model: "point-packages",
    scope: "admin",
  },
  POST_POINT_PACKAGES: {
    path: "/api/v1/point-packages",
    method: "POST",
    model: "point-packages",
    scope: "admin",
  },
  GET_POINT_PACKAGES_ADMIN: {
    path: "/api/v1/point-packages",
    method: "GET",
    model: "point-packages",
    scope: "admin",
  },
  GET_POINT_PACKAGES_PUBLIC: {
    path: "/api/v1/point-packages",
    method: "GET",
    model: "point-packages",
    scope: "public",
  },

  // FCM Notifications
  GET_FCM_NOTIFICATIONS: {
    path: "/api/v1/fcm-notifications",
    method: "GET",
    model: "fcm-notifications",
    scope: "admin",
  },
  GET_FCM_NOTIFICATIONS_BY_ID: {
    path: "/api/v1/fcm-notifications/:id",
    method: "GET",
    model: "fcm-notifications",
    scope: "admin",
  },
  DELETE_FCM_NOTIFICATIONS_BY_ID: {
    path: "/api/v1/fcm-notifications/:id",
    method: "DELETE",
    model: "fcm-notifications",
    scope: "admin",
  },
  PUT_FCM_NOTIFICATIONS_BY_ID: {
    path: "/api/v1/fcm-notifications/:id",
    method: "PUT",
    model: "fcm-notifications",
    scope: "admin",
  },
  POST_FCM_NOTIFICATIONS: {
    path: "/api/v1/fcm-notifications",
    method: "POST",
    model: "fcm-notifications",
    scope: "admin",
  },
  POST_FCM_NOTIFICATIONS_NOTIFY_USER: {
    path: "/api/v1/fcm-notifications/notify-user",
    method: "POST",
    model: "fcm-notifications.notify-user",
    scope: "admin",
  },

  // Settings
  PUT_SETTINGS_BY_ID: {
    path: "/api/v1/settings/:id",
    method: "PUT",
    model: "settings",
    scope: "admin",
  },
  GET_SETTINGS_BY_ID_ADMIN: {
    path: "/api/v1/settings/:id",
    method: "GET",
    model: "settings",
    scope: "admin",
  },
  GET_SETTINGS_BY_ID_PUBLIC: {
    path: "/api/v1/settings/:id",
    method: "GET",
    model: "settings",
    scope: "public",
  },
  GET_SETTINGS_ADMIN: {
    path: "/api/v1/settings",
    method: "GET",
    model: "settings",
    scope: "admin",
  },
  GET_SETTINGS_PUBLIC: {
    path: "/api/v1/settings",
    method: "GET",
    model: "settings",
    scope: "public",
  },
  POST_SETTINGS: {
    path: "/api/v1/settings",
    method: "POST",
    model: "settings",
    scope: "admin",
  },
  DELETE_SETTINGS_BY_ID: {
    path: "/api/v1/settings/:id",
    method: "DELETE",
    model: "settings",
    scope: "admin",
  },

  // Tokens
  GET_TOKENS_BY_ID_OWN: {
    path: "/api/v1/tokens/:id",
    method: "GET",
    model: "tokens",
    scope: "own",
  },
  GET_TOKENS_BY_ID_ADMIN: {
    path: "/api/v1/tokens/:id",
    method: "GET",
    model: "tokens",
    scope: "admin",
  },
  GET_TOKENS_OWN: {
    path: "/api/v1/tokens",
    method: "GET",
    model: "tokens",
    scope: "own",
  },
  GET_TOKENS_ADMIN: {
    path: "/api/v1/tokens",
    method: "GET",
    model: "tokens",
    scope: "admin",
  },

  // Categories
  GET_CATEGORIES_BY_ID_ADMIN: {
    path: "/api/v1/categories/:id",
    method: "GET",
    model: "categories",
    scope: "admin",
  },
  GET_CATEGORIES_BY_ID_PUBLIC: {
    path: "/api/v1/categories/:id",
    method: "GET",
    model: "categories",
    scope: "public",
  },
  PUT_CATEGORIES_BY_ID: {
    path: "/api/v1/categories/:id",
    method: "PUT",
    model: "categories",
    scope: "admin",
  },
  GET_CATEGORIES_ADMIN: {
    path: "/api/v1/categories",
    method: "GET",
    model: "categories",
    scope: "admin",
  },
  GET_CATEGORIES_PUBLIC: {
    path: "/api/v1/categories",
    method: "GET",
    model: "categories",
    scope: "public",
  },
  DELETE_CATEGORIES_BY_ID: {
    path: "/api/v1/categories/:id",
    method: "DELETE",
    model: "categories",
    scope: "admin",
  },
  POST_CATEGORIES: {
    path: "/api/v1/categories",
    method: "POST",
    model: "categories",
    scope: "admin",
  },

  // Users
  GET_USERS_BECOME: {
    path: "/api/v1/users/:id/become",
    method: "GET",
    model: "users",
    scope: "admin",
  },
  DELETE_USERS_BY_ID: {
    path: "/api/v1/users/:id",
    method: "DELETE",
    model: "users",
    scope: "admin",
  },
  GET_USERS_BY_ID: {
    path: "/api/v1/users/:id",
    method: "GET",
    model: "users",
    scope: "admin",
  },
  POST_USERS_REVOKE_ROLE: {
    path: "/api/v1/users/revoke-role",
    method: "POST",
    model: "users",
    scope: "admin",
  },
  PUT_USERS_BY_ID: {
    path: "/api/v1/users/:id",
    method: "PUT",
    model: "users",
    scope: "admin",
  },
  POST_USERS: {
    path: "/api/v1/users",
    method: "POST",
    model: "users",
    scope: "admin",
  },
  POST_USERS_GRANT_ROLE: {
    path: "/api/v1/users/grant-role",
    method: "POST",
    model: "users",
    scope: "admin",
  },
  GET_USERS: {
    path: "/api/v1/users",
    method: "GET",
    model: "users",
    scope: "admin",
  },

  // Banners
  GET_BANNERS_ADMIN: {
    path: "/api/v1/banners",
    method: "GET",
    model: "banners",
    scope: "admin",
  },
  GET_BANNERS_PUBLIC: {
    path: "/api/v1/banners",
    method: "GET",
    model: "banners",
    scope: "public",
  },
  DELETE_BANNERS_BY_ID: {
    path: "/api/v1/banners/:id",
    method: "DELETE",
    model: "banners",
    scope: "admin",
  },
  GET_BANNERS_BY_ID_ADMIN: {
    path: "/api/v1/banners/:id",
    method: "GET",
    model: "banners",
    scope: "admin",
  },
  GET_BANNERS_BY_ID_PUBLIC: {
    path: "/api/v1/banners/:id",
    method: "GET",
    model: "banners",
    scope: "public",
  },
  POST_BANNERS: {
    path: "/api/v1/banners",
    method: "POST",
    model: "banners",
    scope: "admin",
  },
  PUT_BANNERS_BY_ID: {
    path: "/api/v1/banners/:id",
    method: "PUT",
    model: "banners",
    scope: "admin",
  },

  // Permissions
  GET_PERMISSIONS_BY_ID: {
    path: "/api/v1/permissions/:id",
    method: "GET",
    model: "permissions",
    scope: "public",
  },
  GET_PERMISSIONS: {
    path: "/api/v1/permissions",
    method: "GET",
    model: "permissions",
    scope: "public",
  },

  // Roles
  POST_ROLES_REVOKE_ALL: {
    path: "/api/v1/roles/:id/revoke-all",
    method: "POST",
    model: "roles",
    scope: "admin",
  },
  POST_ROLES_GRANT_ALL: {
    path: "/api/v1/roles/:id/grant-all",
    method: "POST",
    model: "roles",
    scope: "admin",
  },
  GET_ROLES_BY_ID: {
    path: "/api/v1/roles/:id",
    method: "GET",
    model: "roles",
    scope: "public",
  },
  PUT_ROLES_BY_ID: {
    path: "/api/v1/roles/:id",
    method: "PUT",
    model: "roles",
    scope: "admin",
  },
  POST_ROLES_GRANT_BY_SCOPE: {
    path: "/api/v1/roles/:id/grant-by-scope",
    method: "POST",
    model: "roles",
    scope: "admin",
  },
  POST_ROLES: {
    path: "/api/v1/roles",
    method: "POST",
    model: "roles",
    scope: "admin",
  },
  GET_ROLES: {
    path: "/api/v1/roles",
    method: "GET",
    model: "roles",
    scope: "public",
  },
  DELETE_ROLES_BY_ID: {
    path: "/api/v1/roles/:id",
    method: "DELETE",
    model: "roles",
    scope: "admin",
  },

  // User Exam Purchases
  GET_USER_EXAM_PURCHASES_ADMIN: {
    path: "/api/v1/user-exam-purchases",
    method: "GET",
    model: "user-exam-purchases",
    scope: "admin",
  },
  GET_USER_EXAM_PURCHASES_STUDENT: {
    path: "/api/v1/user-exam-purchases",
    method: "GET",
    model: "user-exam-purchases",
    scope: "student",
  },
  POST_USER_EXAM_PURCHASES_ADMIN: {
    path: "/api/v1/user-exam-purchases",
    method: "POST",
    model: "user-exam-purchases",
    scope: "admin",
  },
  POST_USER_EXAM_PURCHASES_STUDENT: {
    path: "/api/v1/user-exam-purchases",
    method: "POST",
    model: "user-exam-purchases",
    scope: "student",
  },
  GET_USER_EXAM_PURCHASES_BY_ID_ADMIN: {
    path: "/api/v1/user-exam-purchases/:id",
    method: "GET",
    model: "user-exam-purchases",
    scope: "admin",
  },
  GET_USER_EXAM_PURCHASES_BY_ID_STUDENT: {
    path: "/api/v1/user-exam-purchases/:id",
    method: "GET",
    model: "user-exam-purchases",
    scope: "student",
  },

  // Question Options
  DELETE_QUESTION_OPTIONS_BY_ID_TEACHER: {
    path: "/api/v1/question-options/:id",
    method: "DELETE",
    model: "question-options",
    scope: "teacher",
  },
  DELETE_QUESTION_OPTIONS_BY_ID_ADMIN: {
    path: "/api/v1/question-options/:id",
    method: "DELETE",
    model: "question-options",
    scope: "admin",
  },
  DELETE_QUESTION_OPTIONS_ANSWER_STUDENT: {
    path: "/api/v1/question-options/:id/answer",
    method: "DELETE",
    model: "answer",
    scope: "student",
  },
  DELETE_QUESTION_OPTIONS_ANSWER_ADMIN: {
    path: "/api/v1/question-options/:id/answer",
    method: "DELETE",
    model: "answer",
    scope: "admin",
  },
  GET_QUESTION_OPTIONS_TEACHER: {
    path: "/api/v1/question-options",
    method: "GET",
    model: "question-options",
    scope: "teacher",
  },
  GET_QUESTION_OPTIONS_STUDENT: {
    path: "/api/v1/question-options",
    method: "GET",
    model: "question-options",
    scope: "student",
  },
  GET_QUESTION_OPTIONS_ADMIN: {
    path: "/api/v1/question-options",
    method: "GET",
    model: "question-options",
    scope: "admin",
  },
  GET_QUESTION_OPTIONS_PUBLIC: {
    path: "/api/v1/question-options",
    method: "GET",
    model: "question-options",
    scope: "public",
  },
  POST_QUESTION_OPTIONS_TEACHER: {
    path: "/api/v1/question-options",
    method: "POST",
    model: "question-options",
    scope: "teacher",
  },
  POST_QUESTION_OPTIONS_ADMIN: {
    path: "/api/v1/question-options",
    method: "POST",
    model: "question-options",
    scope: "admin",
  },
  POST_QUESTION_OPTIONS_ANSWER_STUDENT: {
    path: "/api/v1/question-options/:id/answer",
    method: "POST",
    model: "answer",
    scope: "student",
  },
  POST_QUESTION_OPTIONS_ANSWER_ADMIN: {
    path: "/api/v1/question-options/:id/answer",
    method: "POST",
    model: "answer",
    scope: "admin",
  },
  GET_QUESTION_OPTIONS_BY_ID_TEACHER: {
    path: "/api/v1/question-options/:id",
    method: "GET",
    model: "question-options",
    scope: "teacher",
  },
  GET_QUESTION_OPTIONS_BY_ID_STUDENT: {
    path: "/api/v1/question-options/:id",
    method: "GET",
    model: "question-options",
    scope: "student",
  },
  GET_QUESTION_OPTIONS_BY_ID_ADMIN: {
    path: "/api/v1/question-options/:id",
    method: "GET",
    model: "question-options",
    scope: "admin",
  },
  GET_QUESTION_OPTIONS_BY_ID_PUBLIC: {
    path: "/api/v1/question-options/:id",
    method: "GET",
    model: "question-options",
    scope: "public",
  },
  PUT_QUESTION_OPTIONS_BY_ID_TEACHER: {
    path: "/api/v1/question-options/:id",
    method: "PUT",
    model: "question-options",
    scope: "teacher",
  },
  PUT_QUESTION_OPTIONS_BY_ID_ADMIN: {
    path: "/api/v1/question-options/:id",
    method: "PUT",
    model: "question-options",
    scope: "admin",
  },

  // Questions
  POST_QUESTIONS_TEACHER: {
    path: "/api/v1/questions",
    method: "POST",
    model: "questions",
    scope: "teacher",
  },
  POST_QUESTIONS_ADMIN: {
    path: "/api/v1/questions",
    method: "POST",
    model: "questions",
    scope: "admin",
  },
  GET_QUESTIONS_TEACHER: {
    path: "/api/v1/questions",
    method: "GET",
    model: "questions",
    scope: "teacher",
  },
  GET_QUESTIONS_ADMIN: {
    path: "/api/v1/questions",
    method: "GET",
    model: "questions",
    scope: "admin",
  },
  GET_QUESTIONS_STUDENT: {
    path: "/api/v1/questions",
    method: "GET",
    model: "questions",
    scope: "student",
  },
  DELETE_QUESTIONS_BY_ID_TEACHER: {
    path: "/api/v1/questions/:id",
    method: "DELETE",
    model: "questions",
    scope: "teacher",
  },
  DELETE_QUESTIONS_BY_ID_ADMIN: {
    path: "/api/v1/questions/:id",
    method: "DELETE",
    model: "questions",
    scope: "admin",
  },
  GET_QUESTIONS_BY_ID_TEACHER: {
    path: "/api/v1/questions/:id",
    method: "GET",
    model: "questions",
    scope: "teacher",
  },
  GET_QUESTIONS_BY_ID_ADMIN: {
    path: "/api/v1/questions/:id",
    method: "GET",
    model: "questions",
    scope: "admin",
  },
  PUT_QUESTIONS_BY_ID_TEACHER: {
    path: "/api/v1/questions/:id",
    method: "PUT",
    model: "questions",
    scope: "teacher",
  },
  PUT_QUESTIONS_BY_ID_ADMIN: {
    path: "/api/v1/questions/:id",
    method: "PUT",
    model: "questions",
    scope: "admin",
  },

  // FAQs
  GET_FAQS_ADMIN: {
    path: "/api/v1/faqs",
    method: "GET",
    model: "faqs",
    scope: "admin",
  },
  GET_FAQS_PUBLIC: {
    path: "/api/v1/faqs",
    method: "GET",
    model: "faqs",
    scope: "public",
  },
  POST_FAQS: {
    path: "/api/v1/faqs",
    method: "POST",
    model: "faqs",
    scope: "admin",
  },
  GET_FAQS_BY_ID_ADMIN: {
    path: "/api/v1/faqs/:id",
    method: "GET",
    model: "faqs",
    scope: "admin",
  },
  GET_FAQS_BY_ID_PUBLIC: {
    path: "/api/v1/faqs/:id",
    method: "GET",
    model: "faqs",
    scope: "public",
  },
  DELETE_FAQS_BY_ID: {
    path: "/api/v1/faqs/:id",
    method: "DELETE",
    model: "faqs",
    scope: "admin",
  },
  PUT_FAQS_BY_ID: {
    path: "/api/v1/faqs/:id",
    method: "PUT",
    model: "faqs",
    scope: "admin",
  },

  // Auth - OTP
  POST_OTP_REQUEST: {
    path: "/api/v1/otp/request",
    method: "POST",
    model: "otp",
    scope: "public",
  },
  POST_OTP_LOGIN: {
    path: "/api/v1/otp/login",
    method: "POST",
    model: "otp",
    scope: "public",
  },

  // Auth - General
  POST_FORGET_MY_PASSWORD: {
    path: "/api/v1/forget-my-password",
    method: "POST",
    model: "auth",
    scope: "public",
  },
  POST_LOGIN: {
    path: "/api/v1/login",
    method: "POST",
    model: "auth",
    scope: "public",
  },
  POST_RESET_PASSWORD: {
    path: "/api/v1/reset-password",
    method: "POST",
    model: "auth",
    scope: "public",
  },
  GET_LOGOUT: {
    path: "/api/v1/logout",
    method: "GET",
    model: "auth",
    scope: "public",
  },

  // Me (User Profile)
  PUT_ME: {
    path: "/api/v1/me",
    method: "PUT",
    model: "user",
    scope: "own",
  },
  GET_ME: {
    path: "/api/v1/me",
    method: "GET",
    model: "user",
    scope: "public",
  },

  // Meta
  GET_META: {
    path: "/api/v1/meta",
    method: "GET",
    model: "meta",
    scope: "public",
  },
};
